import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CameraEnhanceIcon from "@material-ui/icons/CameraEnhance";
import VideoSelector from "./VideoSelector";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";

import HomeIcon from "@material-ui/icons/Home";
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  emailInput: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  }
}));

function getSteps() {
  return ["Enable camera", "Clear background", "Squat!"];
}

const icons = {
  "Enable camera": CameraEnhanceIcon,
  "Clear background": HomeIcon,
  "Squat!": FitnessCenterIcon
};

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return (
        <p>
          Click{" "}
          <a href="https://www.lifewire.com/configure-camera-microphone-setting-in-google-chrome-4103623">
            here
          </a>{" "}
          if you need help figuring out how to turn on camera. Also make sure no
          other application is using your camera! (Like Facetime or Zoom)
        </p>
      );
    case 1:
      return "Can't workout without a nice background can we? Also improves the accuracy of the counter. Get some nice lighting too! Try facing slightly to the right or left of the camera as well.";
    case 2:
      return "Get as many reps as possible in 60 seconds! Enter in your email to have a chance on the leaderboard!";
    default:
      return "Unknown stepIndex";
  }
}

function EmailInput() {
  const classes = useStyles();

  return (
    <Input
      placeholder="email@example.com"
      required
      className={classes.emailInput}
      id="email-input"
      label="Standard"
    />
  );
}

export default function HorizontalLabelPositionBelowStepper(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const childRef = useRef();

  const handleNext = () => {
    if (activeStep == steps.length - 1) {
      var email = document.getElementById("email-input").value;
      localStorage.setItem("email", email);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    startVideo();
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const startVideo = () => {
    if (activeStep === steps.length - 1) {
      props.startFunc();
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel StepIconComponent={icons[label]}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>
                All steps completed
              </Typography>
              {/* <Button onClick={handleReset}>Reset</Button> */}
            </div>
          ) : (
            <div>
              <Typography className={classes.instructions}>
                {getStepContent(activeStep)}
              </Typography>
              <div>
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                >
                  Back
                </Button>
                {activeStep === steps.length - 1 ? <EmailInput /> : ""}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  {activeStep === steps.length - 1
                    ? "Begin Squatting!"
                    : "Next"}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
    </>
  );
}
